export const STATISTICS_TABLE_TOGGLE = 'STATISTICS_TABLE_TOGGLE'
export const GET_STATISTICS_USER_SORT_FIELDS = 'GET_STATISTICS_USER_SORT_FIELDS'
export const CLEAR_STATISTICS_FILTERS = 'CLEAR_STATISTICS_FILTERS'
export const SELECTED_STATISTICS_ID = 'SELECTED_STATISTICS_ID'
export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const INITIAL_STATISTICS_DATA = 'INITIAL_STATISTICS_DATA'
export const GET_STATISTICS = 'GET_STATISTICS'
export const GET_STATISTIC = 'GET_STATISTIC'
export const GET_STATISTICS_PAGINATION = 'GET_STATISTICS_PAGINATION'
export const SET_CURRENT_STATISTICS_PAGE = 'SET_CURRENT_STATISTICS_PAGE'
export const SET_CURRENT_STATISTICS_SIZE = 'SET_CURRENT_STATISTICS_SIZE'
export const SET_STATISTICS_LOADING = 'SET_STATISTICS_LOADING'
export const SHOW_DETAIL_LOADING = 'SHOW_DETAIL_LOADING'
export const GET_AUDIO_URL = 'GET_AUDIO_URL'
export const SHOW_EXPORT_STATISTICS_LOADING = 'SHOW_EXPORT_STATISTICS_LOADING'
export const SET_FIRST_PAGE = 'SET_FIRST_PAGE';
export const SET_STATISTICS_FILTER = 'SET_STATISTICS_FILTER';
export const SET_STATISTICS_UI_FILTERS = 'SET_STATISTICS_UI_FILTERS';
export const GET_STATISTIC_SORT_FIELDS = 'GET_STATISTIC_SORT_FIELDS';
export const UPDATE_STATISTIC_SORT_FIELDS = 'UPDATE_STATISTIC_SORT_FIELDS';
export const SET_FILES_HISTORY_LOADER = 'SET_FILES_HISTORY_LOADER';
export const GET_FILES_HISTORY = 'GET_FILES_HISTORY'
export const UPDATE_FILES_HISTORY = 'UPDATE_FILES_HISTORY'
export const GET_STATISTICS_FILES_PAGINATION = 'GET_STATISTICS_FILES_PAGINATION'
export const SET_CURRENT_STATISTICS_FILES_PAGE = 'SET_CURRENT_STATISTICS_FILES_PAGE'
export const SET_CURRENT_STATISTICS_FILES_SIZE = 'SET_CURRENT_STATISTICS_FILES_SIZE'
export const SET_RATED_QUESTIONNAIRES = 'SET_RATED_QUESTIONNAIRES'
export const GET_STATISTIC_DASHBOARD = 'GET_STATISTIC_DASHBOARD'
export const SET_STATISTIC_DASHBOARD_LOADING = 'SET_STATISTIC_DASHBOARD_LOADING'
